module.exports = __webpack_public_path__ + "static/media/jobFair.67e52a48.png";